import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, ElementRef } from "@angular/core";
import { ItemGroupViewModel, ItemTagViewModel, NavigationTitleViewModel } from "../../shared/models";
import { Location } from "@angular/common";
import { MenugroupService } from "./menugroup.service";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { CoreLogService } from "../../services/log.service";
import { ActivatedRoute, Router } from "@angular/router";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { SnackBarService } from "../../services/snackBar.service";
import { Paging } from "../../shared/paging";
import { PagingHelper } from "../../shared/pagingHelper";
import { SortOption } from "../../shared/models/sort.model";
import { Subscription } from "rxjs";
import { SortDirection, WebShopMode, ItemTagType } from "../../shared/contentTypes";
import { ScrollHelper } from "../../shared/scrollHelper";
import Utils from "../../shared/utils";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { SwiperConfigInterface } from "ngx-swiper-wrapper";
import { WebShopService } from "../../services/webShop.service";
import { MatTabChangeEvent } from "@angular/material";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { MaterialTabHelperService } from "../../services/materialTabHelper.service";
import { plopInOut } from "../../shared/animation/component.animation";
import { RouterHelperService } from "../../services/routerHelper.service";
import { FilterTagDialogComponent } from "../../modalDialogs";
import { MenuNavDialogComponent } from "../../modalDialogs";
import * as _ from "lodash";
import { ItemTagHelperService } from "../../services/itemTagHelper.service";
import { CoreLanguageService } from "../../services/language.service";
import { InHouseOrderService } from "../../services/inHouseOrder.service";
import * as moment from "moment";
import { OrderTimeValidationService } from "../../services/orderTimeValidation.service";
import { INavigationOptions, TimeSelectionStatus, TimeValidationResult } from "../../services/IOrderTimeValidation.service";
import { NavigationRoute } from "../../shared/enums/navigation-route.enum";
import { RemoteGroupOrderService } from "../../services/RemoteGroupOrder.service";

@Component({
  selector: "app-menugroup",
  templateUrl: "./menugroup.component.html",
  styleUrls: ["./menugroup.component.scss"],
  providers: [MenugroupService, OverlaySpinnerService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [plopInOut]
})
export class MenuGroupComponent implements OnInit, OnDestroy {

  public itemGroups: ItemGroupViewModel[];
  public validItemGroups: ItemGroupViewModel[];
  public paging: Paging<ItemGroupViewModel>;
  public hasData: boolean = true;
  private pagingHelper: PagingHelper = new PagingHelper();
  private pageSize: number = 4;
  private sortOption: SortOption[] = [];
  private locationId: number | null | undefined;
  private menuSettingLocationIds: number[];
  public currentItemGroupTabIndex = 0;
  public atStart = true;
  public atEnd = false;
  private _scrollListener: () => void;
  private _checkScrollTimer: ReturnType<typeof setTimeout>;

  private langSubscriber: Subscription;
  private infiniteScrollSubscriber: Subscription;
  private menuGroupChangesSubscriber: Subscription;
  private _viewTypeSubscription: Subscription;
  private _shippingCartSubscriber: Subscription;

  public emptybasket: boolean = true;
  public itemsInBasket: number = 0;
  private useBrowserHistory: boolean;
  public itemTags: ItemTagViewModel[];
  public isItemTagEnabled: boolean = false;
  public itemTagType: ItemTagType = ItemTagType.Text;

  public pageTitle: NavigationTitleViewModel = new NavigationTitleViewModel(); // Used as a title at the header of the page
  public isSmallView: boolean = false;

  public useRedeemCoupon: boolean = false;

  public tabSliderconfig: SwiperConfigInterface = {
    init: true,
    direction: "horizontal",
    slidesPerView: 4,
    freeMode: true,
    loop: false,
    spaceBetween: 0,
    keyboard: false,
    mousewheel: true,
    scrollbar: false,
    navigation: false,
    pagination: false,
    autoplay: false
  };

  // ViewChildren
  @ViewChild('menugroupitemcontainer') menugroupitemcontainer: any;
  @ViewChild('tabGroup', { read: ElementRef }) tabGroupRef: ElementRef<HTMLElement>;

  constructor(private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _coreLanguageService: CoreLanguageService
    , private _activatedRoute: ActivatedRoute
    , private _router: Router
    , private _routerHelperService: RouterHelperService
    , private _location: Location
    , private _bottomSheetHelperService: BottomSheetHelperService
    , private _menugroupService: MenugroupService
    , private internationalisationService: InternationalisationService
    , private _snackBarService: SnackBarService
    , private _itemTagHelperService: ItemTagHelperService
    , private _overlaySpinnerService: OverlaySpinnerService
    , private _scrollHelper: ScrollHelper
    , private _webshopService: WebShopService
    , private _timeValidationService: OrderTimeValidationService
    , private _materialTabHelperService: MaterialTabHelperService
    , private _mainnavService: MainnavService
    , private _inHouseOrderService: InHouseOrderService
    , private _remoteGroupOrderService: RemoteGroupOrderService) {
    this.isSmallView = this._mainnavService.viewType === ViewType.Small;
  }

  private getHeaderTabs(): HTMLElement | null {
    return this.tabGroupRef ? this.tabGroupRef.nativeElement : null;
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("MenuGroupComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  /**
  * Set the title of the page by title Data in route data
  * This data has been set in RouterHelperService by each navigation Enh Evnt
  */
  async ngOnInit() {
    const me = this;
    me.setRouteData();
    me._webshopService.saveToStorage();
    me.itemTagInitilization();
    me.langSubscriber = this.internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });

    me.menuGroupChangesSubscriber = me._menugroupService.ObserveChanges.subscribe((change) => {
      me.reloadDataAndRender();
    });
    me.setHeaderfocus();
    me.initializeSortAndFilterOption();
    me.setInfiniteScrollSubscriber();
    me.reloadDataAndRender();

    me.onViewTypeChanges(me._mainnavService.viewType);
    me._viewTypeSubscription = me._mainnavService.observeViewTypeChanges.subscribe((viewType) => {
      me.reloadDataAndRender();
      me.onViewTypeChanges(viewType);
      me.PushChanges();
    });

    me._shippingCartSubscriber = me._webshopService.ShippingCartObserver.subscribe((shippingCartItems) => {
      if (shippingCartItems) {
        me.itemsInBasket = me._webshopService.getTotalCountOfItems();
        me.PushChanges();
      } else {
        me.itemsInBasket = 0;
        me.PushChanges();
      }
    });
    me._checkUseRedeemCoupons();

    const headerTabs = me.getHeaderTabs();
    if (!headerTabs) return;
    const scrollContainer = headerTabs.querySelector('.mat-tab-label-container') as HTMLElement;
    if (!scrollContainer) return;

    me._scrollListener = () => {
      me.checkScrollPosition();
      me.PushChanges();
    };
    scrollContainer.addEventListener('scroll', me._scrollListener);

    this.checkScrollPosition();
  }

  private onViewTypeChanges(viewType: ViewType) {
    const me = this;
    me.isSmallView = (viewType === ViewType.Small);
  }

  /**open modal */
  public openTagsModal() {
    const me = this;
    const filterTagButtomSheet = me._bottomSheetHelperService.open(FilterTagDialogComponent, {
      data: { itemTags: _.cloneDeep(me.itemTags), itemTagType: me.itemTagType },
      panelClass: "mat-bottom-sheet-container--full-height"
    });
    filterTagButtomSheet.afterDismissed().subscribe((result: ItemTagViewModel[]) => {
      if (result) {
        me.itemTags = _.cloneDeep(result);
        me.PushChanges();
      }
    });
  }

  public openNavModal() {
    const me = this;
    me._bottomSheetHelperService.open(MenuNavDialogComponent, {
      data: {
        itemGroups: _.cloneDeep(me.itemGroups)
      },
      autoFocus: false,
      panelClass: "mat-bottom-sheet-container-medium"
    });
  }

  private setHeaderfocus() {
    const me = this;
    setTimeout(() => {
      const headerTabs = me.getHeaderTabs();
      if (!headerTabs) return;

      const matTabLabels = Array.from(headerTabs.getElementsByClassName("mat-tab-label")) as HTMLElement[];
      matTabLabels.forEach(label => {
        label.setAttribute("tabIndex", "0");
        label.addEventListener("keydown", (event: KeyboardEvent) => {
          if (event.key === "Enter") {
            event.preventDefault();
            const clickableSpan = label.querySelector('span');
            if (clickableSpan && typeof clickableSpan.click === 'function') {
              clickableSpan.click();
            }
          }
        });
      });

      if (matTabLabels.length > 0) {
        const firstLabel = matTabLabels[0];
        firstLabel.focus();
      }
    }, 200);
  }

  private async _checkUseRedeemCoupons() {
    const me = this;
    const use_redeem_coupon = await me._webshopService.isCouponReedemAllowed(false);
    if (me.useRedeemCoupon != use_redeem_coupon) {
      me.useRedeemCoupon = use_redeem_coupon;
      me.PushChanges();
    }
  }


  public get allowReedemCoupon(): boolean {
    const me = this;
    const serviceId = me._webshopService.getServiceMode();
    return serviceId !== WebShopMode.Viewing;
  }

  public get isRemoteGroupOrder(): boolean {
    const me = this;
    const serviceId = me._webshopService.getServiceMode();
    return serviceId === WebShopMode.PickupGroup || serviceId === WebShopMode.DeliveryGroup;
  }

  private itemTagInitilization() {
    const me = this;
    me._webshopService.getWebshopSettingsDataModel()
      .then(webshopSettings => {
        if (webshopSettings && webshopSettings.is_itemtag_enabled) {
          me._itemTagHelperService.GetProductTags()
            .then(itemTags => {
              if (itemTags && itemTags.length > 0) {
                me.itemTags = itemTags;
                me.isItemTagEnabled = webshopSettings.is_itemtag_enabled;
                me.itemTagType = webshopSettings.itemtag_type;
                me.PushChanges();
              }
            })
            .catch(e => {
              me._coreLogService.error("MenuGroupComponent.itemTagInitilization", "getWebshopSettingsDataModel", e);
            })
        }
      })
      .catch(e => {
        me._coreLogService.error("MenuGroupComponent.itemTagInitilization", "GetProductTags", e);
      })
  }

  /**check if there is liked or unliked tag
 * used to sort products base on liked and disliked tags
 */
  public hasTagSorting() {
    const me = this;
    return me._itemTagHelperService.hasTagSorting(me.itemTags);
  }

  private setRouteData() {
    const me = this;
    me.useBrowserHistory = me._activatedRoute.snapshot.data["useBrowserHistory"];
    me.locationId = +(me._activatedRoute.snapshot.data.locationId);
    me.menuSettingLocationIds = me._activatedRoute.snapshot.data["menuSettingData"].menuSettingLocationIds;
    if (!me.menuSettingLocationIds.includes(me.locationId)) {
      me.locationId = null;
    }
  }

  /**set sorting option and filter at the first loading of the page */
  private initializeSortAndFilterOption() {
    const me = this;
    me.sortOption.push(me.pagingHelper.createSortOption("sort_nr", SortDirection.ASC));
  }

  // set subscriber for scrollbar and load data for next page when it is in the exact point.
  private setInfiniteScrollSubscriber() {
    const me = this;
    me.infiniteScrollSubscriber = me._scrollHelper.InfiniteScrollObserver().subscribe((loadNextPage) => {
      if (loadNextPage && !Utils.IsNull(me.paging)) {
        me.itemGroups.push(...me.paging.nextPage());
        me.PushChanges();
      }
    });
  }

  private async processSelectedServiceTime(): Promise<boolean> {
    const me = this;
    const navigationOptions: INavigationOptions = {
      navigateBeforeDialog: true,
      navigateOnClose: false
    }
    const result: TimeValidationResult = await me._timeValidationService.validateServiceTime(navigationOptions);
    if (result.status === TimeSelectionStatus.Valid) {
      return true;
    }

    if (result.status === TimeSelectionStatus.TimeUpdated) {
      // new valid time selected reload data without validation
      await me.loadDataAndRender();
      return true;
    }

    if (result.status === TimeSelectionStatus.Cancelled) {
      const hasItemsInBasket = me._webshopService.shippingCartItems && me._webshopService.shippingCartItems.length > 0;
      hasItemsInBasket ? me._router.navigate(["/webshop"], { replaceUrl: true }) : me._router.navigate([NavigationRoute.Home], { replaceUrl: true });
      return false;
    } if (result.status === TimeSelectionStatus.NoTimeToSelect) {
      return false; // Don't continue loading data
    }
    return false;
  }

  /** Reloads the data after all required order configuration has been completed. */
  private async reloadDataAndRender(): Promise<void> {
    const me = this;
    if (me.isRemoteGroupOrder && !(await me.ensureRemoteGroupOrderSetup())) {
      return;
    }
    if (me._webshopService.isTimeRequired && !(await me.ensureServiceTime())) {
      return;
    }
    await me.loadDataAndRender();
  }

  /** Verifies remote group order prerequisites (name and deadline) are set. */
  private async ensureRemoteGroupOrderSetup(): Promise<boolean> {
    const me = this;
    if (!me._remoteGroupOrderService.hasDefinedGroupName) {
      await me._router.navigate([NavigationRoute.RemoteOrderGroupDefineName], { replaceUrl: true });
      return false;
    }
    if (!me._remoteGroupOrderService.hasDefinedGroupOrderTime) {
      await me._router.navigate([NavigationRoute.RemoteOrderGroupDefineTime], { replaceUrl: true });
      return false;
    }
    return true;
  }

  /** Verifies a service time is selected; navigates away and returns false if not. */
  private async ensureServiceTime(): Promise<boolean> {
    const me = this;
    if (!(await me._webshopService.hasTimeAlreadySelected())) {
      await me._router.navigate([me.resolveNoTimeSelectedRoute()], { replaceUrl: true });
      return false;
    }
    return me.processSelectedServiceTime();
  }

  /**
   * Resolves the route when no service time is selected yet.
   * Remote group orders always proceed to the group time step.
   */
  private resolveNoTimeSelectedRoute(): NavigationRoute {
    const me = this;
    return me.isRemoteGroupOrder
      ? NavigationRoute.RemoteOrderGroupDefineTime
      : NavigationRoute.OrderTimeSelector;
  }

  private async loadDataAndRender(): Promise<void> {
    const me = this;
    try {
      me.validItemGroups = await me._menugroupService.GetValideItemGroup();

      if (!me.validItemGroups || me.validItemGroups.length === 0) {
        me.itemGroups = [];
        me.hasData = false;
        me.PushChanges();
        return;
      }

      const DefaultPageSize = (me._mainnavService.viewType === ViewType.Small) ? 100 : 200;
      let CurrentPage = 2;
      if (!Utils.IsNull(me.paging)) {
        CurrentPage = me.paging.CurrentPage;
      }
      me.pageSize = (me._mainnavService.viewType === ViewType.Small) ? 100 : 200; // Desktopview supports many more items on 1 page
      me.paging = new Paging(me.validItemGroups, DefaultPageSize, me.sortOption);
      me.itemGroups = []; // clean up
      me.itemGroups.push(...me.paging.initLoad(CurrentPage));
      me.hasData = me.itemGroups.length > 0;
      me.checkScrollPosition();
      me.PushChanges();
      me.animateItems();
    } catch (error) {
      me._coreLogService.error("MenuGroupComponent.reloadDataAndRender", "GetItemGroup", error);
      me._overlaySpinnerService.HideLayoutSpinner();
      me._snackBarService.ShowErrorMessageFailed(65);
    }
  }

  public headerTabFocusChange(event: MatTabChangeEvent) {
    const me = this;
    me._materialTabHelperService.TabHeaderTranslateAnimation(event);
  }

  public headerTabClick(itemGroup: ItemGroupViewModel) {
    if (itemGroup) {
      this.navigateToMenuList(itemGroup);
    }
  }

  public scroll(percentageToScroll: number, direction: 'left' | 'right') {
    const me = this;
    const headerTabs = me.getHeaderTabs();
    if (!headerTabs) return;
    const scrollContainer = headerTabs.querySelector('.mat-tab-label-container') as HTMLElement;
    if (!scrollContainer) return;
    const labels = Array.from(scrollContainer.querySelectorAll('.mat-tab-label')) as HTMLElement[];
    const totalLabelWidth = labels.reduce((sum, label) => sum + label.offsetWidth, 0);
    const scrollAmount = totalLabelWidth * (percentageToScroll / 100);
    const targetScroll = direction === 'right'
      ? scrollContainer.scrollLeft + scrollAmount
      : scrollContainer.scrollLeft - scrollAmount;
    me.animateScroll(scrollContainer, targetScroll);
    me.checkScrollPosition();
  }

  public scrollRight() {
    const me = this;
    me.scroll(window.innerWidth <= 360 ? 10 : window.innerWidth <= 640 ? 15 : 25, 'right');
  }

  public scrollLeft() {
    const me = this;
    me.scroll(window.innerWidth <= 360 ? 10 : window.innerWidth <= 640 ? 15 : 25, 'left');
  }

  private animateScroll(element: HTMLElement, target: number) {
    const startTime = performance.now();
    const start = element.scrollLeft;
    const duration = 1000;
    const easeOut = (t: number) => t * (2 - t);
    const step = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const rawProgress = elapsed / duration;
      const progress = easeOut(rawProgress);
      const scrollPosition = start + (target - start) * progress;
      element.scrollLeft = scrollPosition;
      if (rawProgress < 1) {
        requestAnimationFrame(step);
      }
    };
    requestAnimationFrame(step);
  }

  public checkScrollPosition() {
    const me = this;
    const headerTabs = me.getHeaderTabs();
    if (!headerTabs) return;
    const scrollContainer = headerTabs.querySelector('.mat-tab-label-container') as HTMLElement;
    if (!scrollContainer) return;

    clearTimeout(me._checkScrollTimer);
    me._checkScrollTimer = setTimeout(() => {
      const labels = Array.from(scrollContainer.querySelectorAll('.mat-tab-label')) as HTMLElement[];
      const totalLabelWidth = labels.reduce((sum, label) => sum + label.offsetWidth, 0);
      const maxScrollPosition = Math.ceil(scrollContainer.scrollWidth - scrollContainer.clientWidth);
      const scrollPosition = Math.min(Math.ceil(scrollContainer.scrollLeft), maxScrollPosition);
      const tolerance = maxScrollPosition * 0.01;

      if (scrollPosition <= tolerance && totalLabelWidth >= scrollContainer.clientWidth) {
        me.atStart = true;
        me.atEnd = false;
      } else if (scrollPosition <= tolerance && totalLabelWidth <= scrollContainer.clientWidth) {
        me.atStart = true;
        me.atEnd = true;
      } else if (scrollPosition >= (maxScrollPosition - tolerance)) {
        me.atStart = false;
        me.atEnd = true;
      } else {
        me.atStart = false;
        me.atEnd = false;
      }
      me.PushChanges();
    }, 200);
  }

  public onResize() {
    const me = this;
    me.checkScrollPosition();
  }

  public navigateToMenuList(itemGroup: ItemGroupViewModel) {
    const me = this;
    me._router.navigate(["/menu", itemGroup.id]);
  }

  public navigateToCouponRedeem() {
    const me = this;
    me._router.navigate(["/couponRedeem"]);
  }

  /**When small view is true, navigation back by swiping from left to right.*/
  public SwiperNavigateBack() {
    const me = this;
    if (me.isSmallView == true) {
      me.navigateBack();
    }
  }

  public navigateBack() {
    const me = this;
    if (me.useBrowserHistory) {
      me._location.back();
    } else {
      const serviceMode = me._webshopService.getServiceMode();
      if (serviceMode === WebShopMode.Delivery) {
        me._routerHelperService.setRouteTargetDataByKey("useBrowserHistory", me.useBrowserHistory);
        // todo remove route coordinates and use webshopService
        if (me._webshopService && me._webshopService.PolygonMapInformation && me._webshopService.PolygonMapInformation.Coordinates) {
          me._routerHelperService.setRouteTargetDataByKey("coordinates", me._webshopService.PolygonMapInformation.Coordinates);
        }

        me._router.navigate(["/menulocation"], { replaceUrl: true });
      } else if (serviceMode === WebShopMode.OrderToTable) {
        me._inHouseOrderService.openInHauseLandingPage();
      } else {
        me._webshopService.HasSingleLocation(serviceMode)
          .then(response => {
            if (response) {
              if (serviceMode === WebShopMode.Webvoucher) {
                me._routerHelperService.setRouteTargetDataByKey("useBrowserHistory", me.useBrowserHistory);
                me._router.navigate(["/vouchercredit"], { replaceUrl: true });
              } else {
                me._router.navigate(["/menuservice"], { replaceUrl: true });
              }
            } else {
              me._routerHelperService.setRouteTargetDataByKey("useBrowserHistory", me.useBrowserHistory);
              me._router.navigate(["/menulocation"], { replaceUrl: true });
            }
          })
          .catch(e => {
            me._coreLogService.error("MenuGroupComponent.navigateBack", "_webShopService.HasSingleLocation", e);
            me._snackBarService.ShowErrorMessageFailed(66);
          });
      }
    }
  }

  ngOnDestroy(): void {
    const me = this;
    if (me.langSubscriber) {
      me.langSubscriber.unsubscribe();
    }
    if (me.infiniteScrollSubscriber) {
      me.infiniteScrollSubscriber.unsubscribe();
    }
    if (me.menuGroupChangesSubscriber) {
      me.menuGroupChangesSubscriber.unsubscribe();
    }
    if (me._viewTypeSubscription) {
      me._viewTypeSubscription.unsubscribe();
    }
    if (me._shippingCartSubscriber) {
      me._shippingCartSubscriber.unsubscribe();
    }
    const headerTabs = me.getHeaderTabs();
    if (headerTabs && me._scrollListener) {
      const scrollContainer = headerTabs.querySelector('.mat-tab-label-container') as HTMLElement;
      if (scrollContainer) {
        scrollContainer.removeEventListener('scroll', me._scrollListener);
      }
    }
    clearTimeout(me._checkScrollTimer);
  }

  private animateItems() {
    const me = this;
    if (me.menugroupitemcontainer) {
      const Items = me.menugroupitemcontainer.nativeElement
        .getElementsByClassName("menugroup-item");
      for (let i = 0; i < Items.length; i++) {
        const element = Items[i];
        element.classList.remove("item-animated");
      }
      setTimeout(() => {
        for (let i = 0; i < Items.length; i++) {
          const element = Items[i];
          setTimeout(() => {
            element.classList.add("item-animated");
          }, i * 100)
        }
      }, 100)
    }
  }
}
